import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-communities-preview-section',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule],
  templateUrl: './communities-preview-section.component.html',
  styleUrl: './communities-preview-section.component.scss'
})
export class CommunitiesPreviewSectionComponent {
  communities = [
    {
      title: 'Medical & surgical societies',
      description: 'Professional societies managing renewals, annual meetings, CME, and member directories.',
      icon: 'medical_services',
      route: '/communities/medical-societies'
    },
    {
      title: 'Physician entrepreneurs',
      description: 'Networks for physicians building businesses through memberships, events, and private directories.',
      icon: 'groups',
      route: '/communities/physician-entrepreneurs'
    },
    {
      title: 'Founder networks',
      description: 'Mastermind groups and professional networks built around memberships, events, and payments.',
      icon: 'diversity_3',
      route: '/communities'
    }
  ];
}
